import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ConfigBottomBar, { otherConfigOptionsAttributesFeature } from "../configSetupScreen/widget/configBottomBar";
import "./catelogueConfig/catalogue.css";
import { ConfigOptionsContext } from "../../../../components/newPortal/NewPortalLayout";
import PhoneFrameComponent from "../../../onboarding/PhoneFrame";
import Catalogue from "./catelogueConfig/Catalogue";
import CheckoutFeatureConfig from "./orderSummary/OrderSummaryConfig";
import ManageKPIReview from "../manageKPIReview/manageKPIReview";
import MustDoAction from "../mustDoActions/MustDoAction";
import OrderTrackingFeatureConfig from "../../mandatoryConfigs/optionalFeatures/OrderTrackingConfig/OrderTrackingConfigurations"
import ProjectConfigTemplateOne from "../projectConfig/projectConfigTemplateOne";
import UIandThemeConfigTemplateOne from "../uiThemeConfig/uiConfigTemplateOne";
import CartConfiguration from "../optionalFeatures/cartConfiguration/CartConfiguration";
import ProjectConfigNonStandard from "../projectNonStandard/projectNonStandardConfig";
import AppConfigNonStandard from "../appNonStandardConfig/appNonStandardConfig";
import LoginConfiguration from "../LoginConfiguration/loginConfiguration";
import PasswordConfiguration from "../PasswordConfiguration/passwordConfiguration";
import { useSelector } from "react-redux";
import store from "../../../../stateManagement/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../../../components/loading/Loader";
import FeatureSelectionComponent from "./widget/FeaturesSelectionComponent";
import GenericComponentConfig from "../GenericComponentConfig/GenericComponentConfig";
import ReloadButton from "../uiThemeConfig/widgets/reloadButton";


interface OptionalFeatureLayoutProps {
  children?: React.ReactNode;
  disableBack: boolean;
  handleStepIconClick?: (stepNumber: number) => void;
  setCompleted?: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  currentStep?: number;
  newPortal?:boolean
}


export const mapUiSchemaToType = (value?: string)  => {
  switch ((value ?? "").toLowerCase()) {
    case "select":
      return "select";
    case "track":
      return "track";
    case "image":
      return "image";
    case "checkbox":
      return "checkbox";
    case "textfield":
    case "textField":
      return "textfield";
    case "relatedselect":
      return "relatedSelect";
    case "multiplecheckbox":
      return "multipleCheckbox";
    case "imagelist":
      return "imageList";
    case "colorinput":
    case "colorpicker":
      return "colorInput";
    case "labelinput":
      return "labelInput";
    case "textfieldlist":
      return "textfieldList";
    case "trackorder":
      return "trackOrder";
    case "toggle":
      return "toggle"
    default:
      return "textfield"; 
  }
};
const OptionalFeatureLayout: React.FC<OptionalFeatureLayoutProps> = ({
  disableBack,handleStepIconClick,setCompleted,currentStep,newPortal
}) => {
  const context = useContext(ConfigOptionsContext);
  const savedAppType:any = useSelector(() => store.getState().appTypeState.appType)
  const savedRole:any = useSelector(() => store.getState().roleState.role) ?? savedAppType?.designations?.[0];
  const [dataFieldValidity, setDataFieldValidity] = useState<Record<string, boolean>>({})
  const refs = useRef<Record<string, any>>({});
   const [featureList,setFeatureList]=useState<otherConfigOptionsAttributesFeature[]>([])
  const [subFeature,setSubFeature]=useState<otherConfigOptionsAttributesFeature>()
     
  useEffect(()=>{
    localStorage.setItem("activeChild", "[]")
    // if(disableBack){
    //   localStorage.setItem("activeChild", "[]")
    // }else{
    //   localStorage.removeItem("activeChild")
    // } 
  },[])
 
  const handleBack = () => {
    setOptional(null);
    if(handleStepIconClick){
      handleStepIconClick(1);
    }
  };

  function renderActiveChild(params : string | undefined){

    if(params === undefined){
      params = "";
    }
    const activeId = params!.toLowerCase().replace(/\s+/g, "");
   
    localStorage.setItem("activeChild", activeId)
    switch (activeId) {
       case "mustdoaction":
         return(
         
          <div style={{display:"flex",flexDirection:"column", width:"100%"}} >
          <FeatureSelectionComponent featureList={featureList} setSubFeature={setSubFeature} subFeature={subFeature} />
        { 
        featureList.map((item)=>{
       
          return(
          subFeature?.id===item.id&&<MustDoAction ref={(el) => (refs.current[subFeature?.id??""] = el)} />
        )})}
          </div>
        ) 
      case "kpireview":
        return(
         
          <div style={{display:"flex",flexDirection:"column", width:"100%"}} >
          <FeatureSelectionComponent featureList={featureList} setSubFeature={setSubFeature} subFeature={subFeature} />
        { 
        featureList.map((item)=>{
       
          return(
          subFeature?.id===item.id&&<ManageKPIReview ref={(el) => (refs.current[subFeature?.id??""] = el)} />
        )})}
          </div>
        ) 
        // case "password":
        // return <PasswordConfiguration/>
        
     
     
      //    case "ordersummary":
      //   return <CheckoutFeatureConfig />;
      // case "ordertracking":
      //   return <OrderTrackingFeatureConfig />;
     
       
      // case "project":
      //   return <ProjectConfigTemplateOne />;
      // case "projectnonstandard":
      //   return <ProjectConfigNonStandard />;
      // case "appnonstandard":
      //   return <AppConfigNonStandard />;
     
      // case "cart":
      //   return <CartConfiguration/>;
      
      // case "login":
      //   return <LoginConfiguration/>;
      
      default:
        return(
         
          <div style={{display:"flex",flexDirection:"column", width:"100%"}} >
          <FeatureSelectionComponent featureList={featureList} setSubFeature={setSubFeature} subFeature={subFeature} />
        { 
        featureList.map((item)=>{
       
          return(
          subFeature?.id===item.id&&<GenericComponentConfig key={item.id} subFeature={subFeature} ref={(el) => (refs.current[subFeature?.id??""] = el)}  
           areDataFieldsValid={dataFieldValidity[item.id] ?? true}
  setAreDataFieldsValid={(isValid: boolean) =>
    setDataFieldValidity((prev) => ({
      ...prev,
      [item.id]: isValid,
    }))
  } />
        )})}
          </div>
        ) 
    }
  }
  const { optional, setOptional,uiConfigOptionsProp,setUiConfigOptionsProp } =
  context!;
  const possibleOptions = uiConfigOptionsProp.filter(option => !option.hasOwnProperty('supportedAppTypes') || option.supportedAppTypes?.length === 0 || option.supportedAppTypes?.includes(savedAppType.id) 
  )
  const activeChild = possibleOptions.find((option)=>option.isActive)?.id ?? possibleOptions[0]?.id ?? undefined
  const tempFeatureList = possibleOptions.find((option)=>option.isActive)?.subfeatures ?? possibleOptions[0]?.subfeatures??[]
  useEffect(()=>{
    setFeatureList(tempFeatureList)
    setSubFeature(tempFeatureList[0])
  },[tempFeatureList])

  return ( activeChild ? 
    (<>
      <div className={`catalogueContainer`} style={{display: "flex", flexDirection:"row" , gap:"1%" , height:"100%"}}>
        <div style={{width: "67%"}}>
          <div className="topOptionAndBack">
          {!disableBack && (
            <>
              <IconButton
                color="primary"
                size="small"
                sx={{ fontSize: "1rem", border: "2px solid #1C7EA0" }}
                onClick={handleBack}
              >
                <ArrowBackOutlinedIcon fontSize="small" />
              </IconButton>
            </>
          )}

          <div className="optionalFeatures">
            <ConfigBottomBar
              className="catalougeScroll"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "16px",
                backgroundColor: "white",
                width: "100%",
              }}
              displayMandatory={true}
            />
          </div>
        </div>

        <div className={`configPhoneContainer ${disableBack ? 'shrinked' : ""} ${newPortal ? 'enlarge':""}`}>
          {renderActiveChild(activeChild)}
        </div>
        {newPortal &&  
        <Box marginTop={2} sx={{ position: "absolute", bottom: 10, right: 25 }} style={{zIndex:100}}>
          <Button
            endIcon={
              <ArrowRightAltTwoToneIcon
                sx={{ fontSize: { xl: "50px" }, color: "white" }}
              />
            }
            variant="contained"
            onClick={() => {
              if(setCompleted && currentStep !== undefined){
                setCompleted((prev) => ({
                  ...prev,
                  [currentStep]: true,
                }));
              }
              if(handleStepIconClick){
                handleStepIconClick(3);
              }
              return;
            }} className="confirm-button"
            sx={{
              alignSelf: "flex-end",
              marginY: "1.2rem",
              fontSize: "16px",
            }}
          >
            NEXT STEP
          </Button>
        </Box>}
        </div>
        <div style={{width: "33%",display:"flex",flexDirection:"column",alignItems:"center"}}>
          <div style={{height: "90.5%",marginBottom:"20px"}} id="phone-wrapper">
              <PhoneFrameComponent allowTriggerChanges />
            </div>
   
               <Button
                      disabled={!(dataFieldValidity[subFeature?.id??""]??true )}
                       onClick={() =>{  refs.current[subFeature?.id ?? ""]?.handlePreview?.();
                       }
                       }  
                      sx={{
                      color:"#000000",
                       borderRadius:"8px",
                        fontSize: "12.5px",
                        padding:"8px 14px",
                        backgroundColor: "#ffffff",
                        textTransform:"none",
                        fontWeight:"500",
                        border:"0.5px solid grey"
                      }}
                    >
                      Preview
                    </Button>
                 
            </div>
            <div>

            </div>
        </div>
    
    </>) : 
    (
      <Loader/>
    )
  );
};

export default React.memo(OptionalFeatureLayout);
